const initScrollBlock = () => {
  if(document.querySelector('.scroll-block')){
    const contentBlocks = document.querySelectorAll('.scroll-block__item');
    const pictures = document.querySelectorAll('.scroll-block__media-item');
    const textBlockInViewport = (element) => {
      const rect = element.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      const elementTop = rect.top;
      const elementBottom = rect.bottom;

      const topThreshold = viewportHeight * 0.5; // 50% von der Höhe des Viewports
      const bottomThreshold = viewportHeight * 0.75; // 50% von der Höhe des Viewports

      return (
        elementTop <= (viewportHeight - topThreshold) &&
        elementBottom >= bottomThreshold
      );
    }
    const changeImage = () => {
      let windowWidth = window.innerWidth || document.documentElement.clientWidth;
      for (let i = contentBlocks.length - 1; i >= 0; i--) {
        let block = contentBlocks[i];
        if (textBlockInViewport(block)) {
          const blockId = block.id;
          block.classList.add('active')
          let activeEle = document.querySelector('.scroll-block__media-item[data-block="' + blockId + '"]');
          if (!activeEle.classList.contains('active')) {
            for (let j = 0; j < pictures.length; j++) {
              let element = pictures[j];
              element.classList.remove('active');
            }
            activeEle.classList.add('active');
          }
          if(windowWidth < 992){
            const links = document.querySelectorAll('.scroll-block__nav .scroll-block__nav-item');
            links.forEach(function(element) {
              // Perform actions on each element
              element.classList.remove('active');
            });
            let activeLink = document.querySelector('.scroll-block__nav-item[data-link="' + blockId + '"]');
            activeLink.classList.add('active');
          }
        }
      }
    }
    window.addEventListener('scroll', changeImage);
    window.addEventListener('resize', changeImage);
    window.addEventListener('load', changeImage);
  }
};

export default initScrollBlock;
